<template>
  <el-main>
    <el-input
      placeholder="搜索資訊請輸入關鍵字"
      v-model="title"
      clearable
      @clear="getNewsList"
      autofocus="true"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="getNewsList"
      ></el-button>
    </el-input>
    <div v-if="newsList.length>0" class="news_list">
      <ul>
        <li
          v-for="(it, idx) in newsList"
          :key="idx"
          class="news_item"
          @click="fnToArticle(it.article_id)"
        >
          <el-image :src="it.main_image[0]" fit="cover"></el-image>
          <div class="news_item_info">
            <h3 v-html="it.title"></h3>
            <div class="news_item_time">
              <div>{{ $dayjs(it.publish_time).format("YYYY-MM-DD") }}</div>
              <div class="el-icon-view">{{ it.times }}</div>
            </div>
            <div class="news_item_desc" v-if="it.desctext">
              {{ it.desctext }}
            </div>
          </div>
        </li>
      </ul>
      <el-button type="info" @click="fnToGetMore()">點擊加載更多</el-button>
    </div>
    
  </el-main>
</template>

<script>
import { traditionalized } from "../assets/js/simplifiedToTraditional.js";

export default {
  data() {
    return {
      title: "",
      newsListRes: [],
      start: 0,
      limit: 10,
    };
  },
  watch: {
    title(val) {
      // // console.log(!val)
      this.newsListRes = [];
      this.start = 0;
      if(!val) return false;
      this.getNewsList();
    },
    newsListRes(val){
      // // console.log('document.body.scrollHeight====',document.body.scrollHeight)
      // // console.log('screen.height====',window.screen.height)
    },
    $route(to, from) {
      // console.log('to=====',to);
      this.title=to.query.keyword
      
    },
  },
  computed: {
    newsList() {
      return this.newsListRes.map((item) => {
        // item.main_image = JSON.parse(item.main_image);
        // item.main_image = item.main_image.map(img => !/^http/.test(img) ? this.$imgUrl + img : img);
        try {
          if (item.show_type != 0 && item.main_image != 1 && item.main_image) {
            // alert(item.main_image)
            item.main_image = JSON.parse(item.main_image);
            item.main_image = item.main_image.map((img) =>
              !/^http/.test(img) ? this.$imgUrl + img : img
            );
          }
        } catch (e) {
          // alert(JSON.stringify(e))
          // alert('數據異常，請稍後重試');
        }
        // // console.log(item.main_image)
        if (this.title && this.title.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(traditionalized(this.title), "g");
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text">' +
            traditionalized(this.title) +
            "</span>";
          item.title = item.title.replace(replaceReg, replaceString);
        }
        return item;
      });
    },
  },
  methods: {
    async getNewsList(th) {
      if(!this.title) return false
      let searchJson = {
        title: this.title,
      };
      const { data: res } = await this.$http.get("/api/v2/article/list", {
        params: {
          start: this.start,
          limit: this.limit,
          searchJson: searchJson,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.newsListRes = [...this.newsListRes, ...res.data];
      setTimeout(() => {
        this.$zhTran();
      }, 300);
      
    },
    fnToGetMore() {
      this.start += this.limit;
      this.getNewsList();
    },
    fnToArticle(article_id) {
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
  },
  created() {
    // console.log(this.$route.query.keyword)
    this.title=this.$route.query.keyword
    // console.log(this.$zhTran("個人"));
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 850px;
  margin-top: 60px;
}
.news_list{
  .news_item {
    padding: 15px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    .el-image {
      width: 200px;
      height: 120px;
      margin-right: 26px;
    }
    /deep/.news_item_info {
      // margin-top: 8px;
      flex: 1;
      h3 {
        font-size: 22px;
        line-height: 34px;
        color: #000;
        margin-bottom: 18px;
      }
      .search-text {
        color: #f12e2b;
      }
      .news_item_time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #333333;
        margin-right: 27px;
      }
      .news_item_desc {
        font-size: 14px;
        color: #414141;
        line-height: 22px;
        margin-top: 23px;
      }
      .el-icon-view:before {
        margin-right: 5px;
      }
    }
  }
  .el-button {
    width: 100%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
  }
}

</style>
